import { CssClass } from 'libs/ui/styled';

export const LayoutClasses = {
  main: new CssClass('layout'),
  header: new CssClass('layout-header'),
  content: new CssClass('layout-content'),
  footer: new CssClass('layout-footer'),
} as const;
